import * as types from '../../../../types/masters/stoneAttribute/stoneClarity/stoneClarityTypes';
import * as api from '../../../../../api/masters/stoneAttribute/stoneClarity/stoneClarityApi';

export const fetchStoneClarities = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STONE_CLARITY_REQUEST });
  try {
    const data = await api.fetchStoneClarities();
    dispatch({ type: types.FETCH_STONE_CLARITY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STONE_CLARITY_FAILURE, payload: error.message });
  }
};

export const addStoneClarity = (stoneClarity) => async (dispatch) => {
  try {
    const res = await api.addStoneClarity(stoneClarity);
    dispatch({ type: types.ADD_STONE_CLARITY_SUCCESS, payload: res });
    dispatch(fetchStoneClarities());
  } catch (error) {
    dispatch({ type: types.STONE_CLARITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateStoneClarity = (id, stoneClarity) => async (dispatch) => {
  try {
    console.log('Updating stone clarity with ID:', id, 'Data:', stoneClarity);
    const res = await api.updateStoneClarity(id, stoneClarity);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_STONE_CLARITY_SUCCESS, payload: res });
    dispatch(fetchStoneClarities());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.STONE_CLARITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteStoneClarity = (id) => async (dispatch) => {
  try {
    await api.deleteStoneClarity(id);
    dispatch({ type: types.DELETE_STONE_CLARITY_SUCCESS, payload: id });
    dispatch(fetchStoneClarities());
  } catch (error) {
    dispatch({ type: types.STONE_CLARITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setStoneClarityEdit = (stoneClarity) => ({
  type: types.SET_STONE_CLARITY_EDIT,
  payload: stoneClarity,
});

export const clearStoneClarityEdit = () => ({
  type: types.CLEAR_STONE_CLARITY_EDIT,
}); 